import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './../../util/confirm-dialog/confirm-dialog.component';
import { ParametrosConst } from './../../util/parametrosConst';
import { ConfirmDialog } from './../../util/confirm-dialog/confirmDialog';
import {Component, OnInit} from '@angular/core';
import {Pregunta} from '../../model/pregunta';
import {Asistente} from '../../model/asistente';
import {Votacion} from '../../model/votacion';
import { UntypedFormControl, UntypedFormArray, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import {AlertaService} from 'src/app/util/alerta.service';
import {VotacionService} from '../votacion.service';
import {Router} from '@angular/router';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'sura-votacion-remota',
  templateUrl: './votacion-remota.component.html',
  styleUrls: ['./votacion-remota.component.scss']
})
export class VotacionRemotaComponent implements OnInit {
  listaVotacion: Votacion[] = [];
  listaPreguntas: Pregunta[] = [];
  preguntaActual: Pregunta = new Pregunta();
  indicePregActual = 0;
  asistente: Asistente = new Asistente();
  votacionForm: UntypedFormGroup;
  isBtnDisabled = false;
  showFinalizar: Observable<boolean> = of(false);

  constructor(private router: Router,
    private _votacionService: VotacionService,
    private alertaService: AlertaService,
    public dialogConfirmar: MatDialog,
    private _formBuilder: UntypedFormBuilder) {
      this.votacionForm = this._formBuilder.group({
        votacionArray: this._formBuilder.array([])
    });
  }

  ngOnInit() {
    this.asistente = this._votacionService.getCurrentUser() || new Asistente;
    this.obtenerPreguntas();
  }

  async obtenerPreguntas() {
    this.indicePregActual = 0;
    await this._votacionService.obtenerPreguntaActiva(
      this.asistente.idAsamblea,
      this.asistente.id,
      this.asistente.idFoto,
      'R',
      'P'
    )
    .then(listaPreguntas => {
      if (listaPreguntas instanceof Array && listaPreguntas.length === 0) {
        this.alertaService.error('Usted no tiene preguntas por responder');
      } else {
        (listaPreguntas as Array<Pregunta>).forEach((_pregunta, indice) => {

          if (_pregunta.tipoPregunta === 1) {
            this.votacionArray.push(new UntypedFormControl(''));
          } else {
            const checks = new UntypedFormArray([]);
            for (let k = 0; k < _pregunta.opciones.length; k++) {
              checks.push(new UntypedFormControl(false));
            }
            this.votacionArray.push(checks);
          }

          this.listaPreguntas.push(_pregunta);

          const votacion = new Votacion();
          votacion.idOpcion = listaPreguntas[indice].opciones[0].id;
          votacion.voto = null;
          votacion.idAsamblea = this.asistente.idAsamblea;
          votacion.idFoto = this.asistente.idFoto;
          votacion.idPregunta = listaPreguntas[indice].id;
          votacion.peso = this.asistente.peso;
          votacion.usuarioRegistro = this.asistente.nombres + ' ' + this.asistente.apellidos;
          this.listaVotacion.push(votacion);
        });

      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  fnIsDone(tabIndex: number) {
    console.log(tabIndex);
    if (tabIndex === null || tabIndex === undefined) {
      return;
    }

    if ((tabIndex + 1) === this.listaPreguntas.length) {
      this.showFinalizar = of(true);
    } else {
      this.showFinalizar = of(false);
    }
  }

  enviarVotacion() {
    const faltanVotos = this.listaVotacion.filter(voto => voto.voto == null).length;
    if (faltanVotos) {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_INCOMPLETO, 'CUIDADO');
    } else {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_COMPLETO, 'CONFIRMAR');
    }
  }


  showConfirmarFinalizar(mensaje: string, titulo: string) {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = mensaje;
    confirmDialog.submessage = ParametrosConst.MSJ_FINALIZAR_VOTO_NOTA;
    confirmDialog.titulo = titulo;
    confirmDialog.labelOk = 'Finalizar';
    const dialogRef = this.dialogConfirmar.open(ConfirmDialogComponent, {
      width: '500px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
          this._votacionService.generarVotacionRemota(this.listaVotacion).then(res => {
            this._votacionService.votacionHistorico(this.asistente.idAsamblea, this.asistente.idFoto).then(r => {
              this.alertaService.success(res);
              this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
            }).catch(err => {
              this.alertaService.info(err);        
            });
          
          }
        ).catch(err => {
          this.alertaService.error(err);
        });
      }
    });
  }

  get votacionArray() {
    return this.votacionForm.get('votacionArray') as UntypedFormArray;
  }

  onChangeRadio(event, i) {
    this.listaVotacion[i].voto = event.source.value;
  }

  onChangeCheckBox(event, i) {
    const numOpc = this.listaPreguntas[i].numOpc;
    const voto = this.listaVotacion[i].voto;
    if (event.checked) {
      if (voto != null && voto.split(',').length >= numOpc) {
        this.alertaService.warning('Ya no puede marcar mas opciones');
        event.source.value = false;
        return false;
      } else {
        if (voto != null) {
          const votoFinal = voto.split(',');
          votoFinal.push(event.source.value);
          this.listaVotacion[i].voto = votoFinal.join(',');
        } else {
          this.listaVotacion[i].voto = event.source.value;
        }
      }
    } else {
      const votoFinal = voto.split(',').filter(opc => opc !== event.source.value);
      if (votoFinal.length > 0) {
        this.listaVotacion[i].voto = votoFinal.join(',');
      } else {
        this.listaVotacion[i].voto = null;
      }
    }

    if (this.listaVotacion[i].voto != null && this.listaVotacion[i].voto.split(',').length === numOpc) {
      this.listaPreguntas[i].isDisabled = true;
      this.isBtnDisabled = false;
    } else {
      if (this.listaVotacion[i].voto == null) {
        this.isBtnDisabled = false;
      } else {
        this.isBtnDisabled = true;
      }
      this.listaPreguntas[i].isDisabled = false;
    }
  }

}
